import { render, staticRenderFns } from "./LivestreamDetails.vue?vue&type=template&id=07e52834&"
import script from "./LivestreamDetails.vue?vue&type=script&lang=js&"
export * from "./LivestreamDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports